"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Schedules;
(function (Schedules) {
    Schedules["CONTACT_HOURS"] = "Mon - Fri 5am - 5pm PT";
})(Schedules || (Schedules = {}));
exports.default = Schedules;
//# sourceMappingURL=schedules.js.map